import {Injectable} from '@angular/core';

import {WindowRef} from './window.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {

  constructor(private windowRef: WindowRef) {}

  getItem(key: string): string | null {
    return this.windowRef.nativeWindow.localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    this.windowRef.nativeWindow.localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    this.windowRef.nativeWindow.localStorage.removeItem(key);
  }
}
